import React from "react";
import { useTable } from "../../Components/useTable";

const BussinessDevelopersList = () => {
  const type = "Bussiness-developers";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "Rid" },
    { id: "picture", numeric: false, label: "Picture" },
    { id: "userName", numeric: false, label: "Name" },
    { id: "email", numeric: false, label: "Email" },
    { id: "phone", numeric: false, label: "Phone" },
    { id: "id", numeric: false, label: "UID" },
    { id: "status", numeric: false, label: "Status" },
    { id: "dropdown", numeric: false, label: "Change Status" },
    { id: "bankName", numeric: false, label: "Bank Name" },
    { id: "bankAccountName", numeric: false, label: "Account Number" },
    { id: "country", numeric: false, label: "Country" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default BussinessDevelopersList;
